import React, { Fragment } from "react";

type ButtonWhiteProps = {
  text: string;
  functionButton: () => void;
};

export const ButtonWhite: React.FC<ButtonWhiteProps> = ({
  text,
  functionButton,
}) => (
  <Fragment>
    <button
      type="button"
      className="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
      onClick={functionButton}
    >
      {text}
    </button>
  </Fragment>
);
